import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '../ui/button';

const LOGO_HORIZONTAL = "https://customer-assets.emergentagent.com/job_hospital-bess-losung/artifacts/0ddmwbwo_Hospital%20BESS.svg";

const navItems = [
  { name: 'Wirtschaftlichkeit', path: '/wirtschaftlichkeit' },
  { name: 'Anwendungsfälle', path: '/anwendungsfaelle' },
  { name: 'Technologie', path: '/technologie' },
  { name: 'Prozess', path: '/prozess' },
  { name: 'FAQ', path: '/faq' },
  { name: 'Über uns', path: '/ueber-uns' },
];

export const Navbar = ({ onContactClick }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-100" data-testid="navbar">
      <div className="container-main">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-testid="logo-link">
            <img 
              src={LOGO_HORIZONTAL} 
              alt="Hospital-BESS" 
              className="h-10 sm:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                  location.pathname === item.path
                    ? 'text-[#10B981] bg-emerald-50'
                    : 'text-slate-600 hover:text-[#0F172A] hover:bg-slate-50'
                }`}
                data-testid={`nav-${item.path.replace('/', '')}`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:block">
            <Button 
              onClick={onContactClick}
              className="btn-primary"
              data-testid="navbar-contact-btn"
            >
              Beratung anfragen
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 text-slate-600"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-slate-100" data-testid="mobile-menu">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-4 py-3 text-sm font-medium rounded-md transition-colors ${
                    location.pathname === item.path
                      ? 'text-[#10B981] bg-emerald-50'
                      : 'text-slate-600 hover:text-[#0F172A] hover:bg-slate-50'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-${item.path.replace('/', '')}`}
                >
                  {item.name}
                </Link>
              ))}
              <div className="pt-4 px-4">
                <Button 
                  onClick={() => {
                    setMobileMenuOpen(false);
                    onContactClick();
                  }}
                  className="btn-primary w-full"
                  data-testid="mobile-contact-btn"
                >
                  Beratung anfragen
                </Button>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};
